import React from 'react';
import { SvgIcon } from '@material-ui/core';

const SignWarning = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve1" d="M5680 1282l3846 6712c117,205 117,439 0,644 -117,205 -319,322 -554,322l-7691 0c-234,0 -436,-117 -553,-322 -117,-205 -117,-439 0,-644l3846 -6712c117,-205 318,-322 553,-322 235,0 436,117 553,322zm-560 318l-3840 6720 7680 0 -3840 -6720z"/>
	<path id="curve0" d="M5120 6720c353,0 640,287 640,640 0,353 -287,640 -640,640 -353,0 -640,-287 -640,-640 0,-353 287,-640 640,-640zm-320 -2880l640 0c176,0 320,144 320,320l0 802c0,110 -12,204 -38,311l-252 1006c-18,72 -81,121 -155,121l-390 0c-74,0 -137,-49 -155,-121l-252 -1006c-26,-107 -38,-201 -38,-311l0 -802c0,-176 144,-320 320,-320z"/>
    </SvgIcon>
);
export default SignWarning;

